<template>
  <div class="notfound-container">
    <!-- 导航栏 -->
    <HeaderComponent />

    <!-- 404内容区域 -->
    <section class="notfound-content">
      <div class="container">
        <div class="notfound-wrapper">
          <div class="notfound-icon">
            <i class="fas fa-exclamation-triangle"></i>
          </div>
          <h1 class="notfound-title">404</h1>
          <h2 class="notfound-subtitle">页面不存在</h2>
          <p class="notfound-text">抱歉，您访问的页面不存在或已被移除。</p>
          <router-link to="/home" class="btn btn-primary btn-large">返回首页</router-link>
        </div>
      </div>
    </section>

    <!-- 页脚 -->
    <FooterComponent />
  </div>
</template>

<script>
import HeaderComponent from '../components/Header.vue'
import FooterComponent from '../components/Footer.vue'

export default {
  name: 'NotFoundView',
  components: {
    HeaderComponent,
    FooterComponent
  }
}
</script>

<style scoped>
.notfound-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}


/* 404内容区域 */
.notfound-content {
  padding: 180px 0 120px;
  text-align: center;
  min-height: calc(100vh - 280px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.notfound-wrapper {
  max-width: 600px;
  margin: 0 auto;
}

.notfound-icon {
  font-size: 80px;
  color: #667eea;
  margin-bottom: 30px;
  opacity: 0.8;
}

.notfound-title {
  font-size: 120px;
  font-weight: 800;
  color: #333;
  margin-bottom: 10px;
  line-height: 1;
}

.notfound-subtitle {
  font-size: 36px;
  font-weight: 700;
  color: #666;
  margin-bottom: 20px;
}

.notfound-text {
  font-size: 18px;
  color: #999;
  margin-bottom: 40px;
  line-height: 1.6;
}

.btn {
  padding: 12px 30px;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
  text-decoration: none;
  display: inline-block;
}

.btn-primary {
  background-color: #667eea;
  color: white;
}

.btn-primary:hover {
  background-color: #5568d3;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.3);
}

.btn-large {
  padding: 16px 40px;
  font-size: 18px;
}



/* 响应式设计 */
@media (max-width: 768px) {
  
  .notfound-title {
    font-size: 80px;
  }
  
  .notfound-subtitle {
    font-size: 28px;
  }
  
  .notfound-text {
    font-size: 16px;
  }
}

@media (max-width: 480px) {
  .notfound-content {
    padding: 150px 0 100px;
  }
  
  .notfound-icon {
    font-size: 60px;
  }
  
  .notfound-title {
    font-size: 60px;
  }
  
  .notfound-subtitle {
    font-size: 24px;
  }
  
  .btn-large {
    padding: 14px 30px;
    font-size: 16px;
  }
}
</style>